import { Form } from "react-final-form";

import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";

import { useEffect, useState } from "react";
import DeviceOtherModalStepOne from "./Steps/DeviceOtherModalStepOne";
import { onSubmit, onValidate } from "./DeviceOtherModalSubmit";

const DeviceForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        priceList: _initialValues?.priceList?.uuid
          ? {
              ..._initialValues?.priceList,
              name: _initialValues?.priceList?.index,
              uuid: _initialValues?.printerModel?.uuid,
            }
          : null,
      });
    } else {
      setInitialValues({});
    }
  }, [update, _initialValues]);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="DeviceOtherModalForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <DeviceOtherModalStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default DeviceForm;
